/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Box,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { blank, getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import LoadingModal from "../../../components/LoadingModel/loadingModal";

import { addBuRole, fetchBURoleByID, updateBuRole } from "utils/api";
import { generateDataList } from "utils/generic";
import { fetchPlanNames } from "utils/superAdminApi";

import { getColorMappings } from "components/ColorComponent/ColorComponent";
import PageTitle from "examples/PageTitle/PageTitle";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


let routePath = "/myroles";



function EditBURoles() {
  const { id } = useParams();
  let payloadUpdate = [];
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [roleNameErr, setRoleNameErr] = useState(false);
  const [associatedPlanNameErr, setAssociatedPlanNameErr] = useState(false);
  const [screenName, setScreenName] = useState("Add New Role");
  const [toggleStatus, setToggleStatus] = useState(false);
  const [defaultPlanRole, setDefaultPlanRole] = useState(false);
  const [loading, setLoading] = useState(false);
  const [planNames, setPlanNames] = useState([]);
  const [openPlanDefaultRoleModal, setOpenPlanDefaultRoleModal] = useState(false);
  const [roleInUse, setRoleInUse] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [uniqueMenuName, setUniqueMenuName] = useState([]);
  const [values, setValues] = React.useState({
    roleName: "",
    roleDescription: "",
    applicableForBusinessUser: "No",
    planID: "",
    permission: [],
    defaultPlanRole: "No",
  });

  const [values1, setValues1] = React.useState({
    _id: "",
  });

  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };


  useEffect(() => {
    let LOGIN_DETAILS;
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
    values.businessUserID = LOGIN_DETAILS?.businessUserID
    values.userID = LOGIN_DETAILS._id;
    id === undefined ? setScreenName("Add New Role") : setScreenName("Edit Role");
    (async () => {
      getRight();
      fetchPlanNamesData();
      if (id !== undefined) {
        values1._id = id;
        fetchBURoleByID(values1, (data) => {
          setUniqueMenuName(data.Result_Output);
          setValues(data.Result_Output[0]);
        }, dispatch)
      } else {
        let ROLE_RIGHTS = JSON.parse(sessionStorage.getItem('ROLE_RIGHTS_LOGIN'));
        ROLE_RIGHTS.map((val, i) => {
          if (val.screenRight === "Full Access") {
            delete val._id
            uniqueMenuName.push(val)
          }
        })

      }
    }
    )();
  }, [dispatch])

  async function getRight() {
    let right = await getScreenRight("Roles")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(false)

  }
  const clearErrorStates = () => {
    setRoleNameErr(false);
    setAssociatedPlanNameErr(false);
  };
  const addNewRoles = async () => {
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag = validateField(values.roleName, setRoleNameErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const apiFunction = id === undefined ? addBuRole : updateBuRole;
    apiFunction({ values: values, permission: uniqueMenuName }, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };
  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const handleKeyDown = (e) => {
    const inputElement = document.querySelector('.GoogleInput');
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };



  useEffect(() => {
    if (toggleStatus === true) {
      values.applicableForBusinessUser = "Yes";
    } else {
      values.applicableForBusinessUser = "No";
      // eslint-disable-next-line no-useless-computed-key
      setValues({ ...values, ["planID"]: "" });
      setDefaultPlanRole(false);
    }
  }, [toggleStatus]);

  useEffect(() => {
    if (defaultPlanRole === true) {
      values.defaultPlanRole = "Yes";
    } else {
      values.defaultPlanRole = "No";
    }
  }, [defaultPlanRole]);

  const fetchPlanNamesData = async () => {

    fetchPlanNames(values, async (data) => {

      setPlanNames(await generateDataList(data.Result_Output, "_id", "planName"));
    });
  };



  const handlePlanDefaultRole = async () => {
    if (!defaultPlanRole) setOpenPlanDefaultRoleModal(true);
    else setDefaultPlanRole(!defaultPlanRole);
  };

  const handleCancel = async () => {
    setOpenPlanDefaultRoleModal(false);
  };

  const changePlanDefaultRole = () => {
    setOpenPlanDefaultRoleModal(false);
    setDefaultPlanRole(!defaultPlanRole);
  }; const handleChange1 = (name, index) => (event) => {

    if (event.target.value) {
      let newArr = [...uniqueMenuName];
      newArr[index][name] = event.target.value;
      setUniqueMenuName(newArr);
      payloadUpdate.push(newArr[index]);
    }
  };



  var dropicons = document.querySelectorAll('.MuiInputBase-root');
  for (let i = 0; i < dropicons.length; i++) {
    var svgicon = dropicons[i].getElementsByTagName('svg');
    if (svgicon.length > 0) {
      if (darkMode) {
        svgicon[0].setAttribute("style", "fill: white !important; ");

      } else {
        svgicon[0].setAttribute("style", "fill: ");
      }
    }
  }




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card sx={{ boxShadow: "none", paddingBottom: "20px" }}>
          <PageTitle screenName={screenName} />
          <MDBox mt={3} mb={3}>

            {/* <Card sx={{ boxShadow: "none", paddingBottom: "20px" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox> */}

            <Grid container
              p={1.6}
              mb={0.9}
              columnSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
              rowSpacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}>

              <Grid xs={4} mt={2}>
                <MDBox mb={4} xs={12} px={3.4}>
                  <TextField
                    type="text"
                    label="Role Name"
                    variant="outlined"
                    autoFocus={true}

                    fullWidth
                    inputProps={{
                      pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                      maxLength: 30,
                      className: "custom-fieldtext"
                    }}
                    onChange={handleChange("roleName")}
                    value={values.roleName}
                  />
                  {roleNameErr ? <span style={errMsg}>Role Name can't be blank</span> : ""}
                </MDBox>
              </Grid>
              <Grid xs={5} mt={2}>
                <MDBox mb={4} xs={12}>
                  <TextField
                    type="text"
                    label="Role Description (Optional)"
                    variant="outlined"
                    autoFocus={true}
                    fullWidth
                    inputProps={{
                      pattern: "^[a-zA-Z0-9!@#$%^&*()_+=-{};:'<>,./?]+$",
                      maxLength: 30,
                      className: "custom-fieldtext"
                    }}
                    onChange={handleChange("roleDescription")}
                    value={values.roleDescription}
                  />
                </MDBox>
              </Grid>
            </Grid>

            <Grid container rowSpacing={2} mb={-1}>
              {uniqueMenuName.map((val, i) => (
                <>
                  <Grid item container lg={3} md={2} xs={12} key={i} px={1} >
                    <FormControl fullWidth sx={{ m: 1, width: "96%", height: "100%" }}>
                      <InputLabel id="demo-simple-select-label">{val.screenName}</InputLabel>
                      <Select
                        id="demo-simple-select"
                        labelId="demo-simple-select-label"
                        value={val.screenRight}
                        style={{ height: "35.11px" }}
                        onChange={handleChange1("screenRight", i)}
                        label={val.screenName}
                        sx={{
                          "& .MuiSelect-icon": {
                            color: darkMode ? "white" : "black"
                          },
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: darkMode ? "white" : "initial"
                            },
                            "&:hover fieldset": {
                              borderColor: darkMode ? "white" : "initial"
                            }
                          }
                        }}
                      >
                        <MenuItem value="None">None</MenuItem>
                        <MenuItem value="Full Access">Full Access</MenuItem>
                        <MenuItem value="View Only">View Only</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                </>
              ))}
            </Grid>

            <Grid
              container
              mt={2}
              // columnSpacing={{ xs: 2, md: 4, lg: 4 }}
              // columnSpacing={4}
              alignItems="center"
              spacing={2}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Grid item xs={12} md={4} spacing={2} lg={2.04}>
                <Link to={"/myroles"}>
                  <MDButton
                    className="btn-block center-container-btn btn-warning btn-back rightSpace"
                    color="warning"
                    fullWidth
                    style={{ height: "40px" }}
                  >
                    Close
                  </MDButton>
                </Link>
              </Grid>
              <Grid item xs={12} md={4} spacing={2} lg={2.041}>
                <MDButton
                  onClick={disableColor ? blank : addNewRoles}
                  rel="noreferrer"
                  variant="gradient"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color={disableColor ? "secondary" : "success"}
                  fullWidth
                  style={{ height: "40px" }}
                >
                  {id !== undefined ? <>Update</> : <>Save</>}

                </MDButton>
              </Grid>
            </Grid>
            {/* </Card> */}


          </MDBox>

          <>

            <Height val={20} />
            <Modal
              open={openPlanDefaultRoleModal}
              onClose={() => handleCancel()}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Card sx={style}>
                <Box >
                  <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "black" }}>
                    Would you like to set this role as plan default role?
                  </Typography>
                  <Grid container id="modal-modal-description" sx={{ mt: 2, justifyContent: "center" }}>
                    <MDButton color="warning" onClick={() => handleCancel()} style={{ width: "70px" }}>
                      No
                    </MDButton>
                    &nbsp; &nbsp;
                    <MDButton color="success" onClick={changePlanDefaultRole} style={{ width: "70px" }}>
                      Yes
                    </MDButton>
                  </Grid>
                </Box>
              </Card>
            </Modal>
          </>
        </Card>
      </div>
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default EditBURoles;
